import { useQuery } from '@tanstack/react-query';
import { settingsService } from '../services/settings.service';

export function useProfile() {
  return useQuery({
    queryKey: ['profile'],
    queryFn: () => settingsService.getProfile(),
  });
}
